import { createApi } from "@reduxjs/toolkit/query/react";
import CustomFetchBase from "../CustomFetchBase";

export const ComplaintApi = createApi({
  reducerPath: "ComplaintApi",
  baseQuery: CustomFetchBase,
  tagTypes: ["COMPLAINTAPI"],
  endpoints: (build) => ({
    createComplaint: build.mutation({
      query: ({ data }) => ({
        url: `/complaints`,
        method: "POST",
        body: data,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["COMPLAINTAPI"],
    }),
    getMyComplaints: build.query({
      query: () => ({
        url: `/complaints/my-complaints`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["COMPLAINTAPI"],
    }),

    // Get complaint by ID
    getComplaintById: build.query({
      query: ({ id }) => ({
        url: `/complaints/${id}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["COMPLAINTAPI"],
    }),

    // Add attachment to a complaint
    addComplaintAttachment: build.mutation({
      query: ({ id, data }) => ({
        url: `/complaints/${id}/attachment`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["COMPLAINTAPI"],
    }),

    // Get all complaints (admin only)
    getAllComplaints: build.query({
      query: ({
        page,
        searchTerm = "",
        status = "",
        type = "",
        priority = "",
        assignedTo = "",
      }) => ({
        url: `/complaints?page=${page}&searchTerm=${searchTerm}&status=${status}&type=${type}&priority=${priority}&assignedTo=${assignedTo}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["COMPLAINTAPI"],
    }),

    // Complaint analytics/stats (admin)
    getComplaintStats: build.query({
      query: () => ({
        url: `/complaints/analytics/stats`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["COMPLAINTAPI"],
    }),

    // Update complaint status
    updateComplaintStatus: build.mutation({
      query: ({ id, data }) => ({
        url: `/complaints/${id}/status`,
        method: "PATCH",
        body: data,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["COMPLAINTAPI"],
    }),

    // Assign complaint
    assignComplaint: build.mutation({
      query: ({ id, data }) => ({
        url: `/complaints/${id}/assign`,
        method: "PATCH",
        body: data,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["COMPLAINTAPI"],
    }),

    // Resolve complaint
    resolveComplaint: build.mutation({
      query: ({ id, data }) => ({
        url: `/complaints/${id}/resolve`,
        method: "PATCH",
        body: data,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["COMPLAINTAPI"],
    }),

    // Update complaint priority
    updateComplaintPriority: build.mutation({
      query: ({ id, data }) => ({
        url: `/complaints/${id}/priority`,
        method: "PATCH",
        body: data,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["COMPLAINTAPI"],
    }),
    // Delete complaint
    deleteComplaint: build.mutation({
      query: ({ id }) => ({
        url: `/complaints/${id}`,
        method: "DELETE",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["COMPLAINTAPI"],
    }),

    // Get complaints for a specific user (admin)
    getComplaintsByUser: build.query({
      query: ({ userId }) => ({
        url: `/complaints/user/${userId}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["COMPLAINTAPI"],
    }),
  }),
});

export const {
  useCreateComplaintMutation,
  useGetMyComplaintsQuery,
  useGetComplaintByIdQuery,
  useAddComplaintAttachmentMutation,
  useGetAllComplaintsQuery,
  useGetComplaintStatsQuery,
  useUpdateComplaintStatusMutation,
  useAssignComplaintMutation,
  useResolveComplaintMutation,
  useUpdateComplaintPriorityMutation,
  useDeleteComplaintMutation,
  useGetComplaintsByUserQuery,
} = ComplaintApi;
